import axios from 'axios'
import { getUserToken } from '../../../functions.js'
import { getServerApi, getCloudFunctionBase } from '../../../config/deployment'
import keys from '../../../config/keys.json'
import { performRequest_GET, performRequest_POST, performRequest_PUT } from '@/platform/utils/http/httpService'

let envUri = getServerApi()
let analyticsVisitsUri = getCloudFunctionBase() + '/cf-listing-stats/visits'
let analyticsUri = envUri + '/api/analytics'

export const getListingViews = (listingId, accountId) => {
  return getUserToken()
    .then(token => {
      return axios.get(analyticsUri + "/listing/views", { params: { token: token, maaklerID: listingId, accountId: accountId } })
    })
    .then(resp => {
      return resp.data.body || [];
    })
    .catch(err => {
      console.log('err:', err);
      return []
    })
   
}


export const getListingVisits = (listingId, accountId) => {
  return axios.get(analyticsVisitsUri + "/" + listingId, { params: { accountId: accountId }, headers: { "Authorization": keys.internal_cf_auth_token } })
    .then(resp => {
      if (resp.data.result) return resp.data.result[0].visits
      return []
    })
    .catch(err => {
      return []
    })
}

export const addListingVisit = (listingId, visit) => {
  var data = {
    listingMID: listingId,
    visit: visit
  }
  var headers = { "Authorization": keys.internal_cf_auth_token };

  return axios.post(analyticsVisitsUri, data, { headers: headers })
    .then(resp => {
      return true
    })
    .catch(err => {
      console.log('then | err:', err);
      return false
    })
}


// WEBPACK FOOTER //
// ./src/platform/analytics/repositories/analyticsRepository.js